import React from 'react';
import { Card, CardContent } from './ui/card';
import { Award, TrendingUp, Percent } from 'lucide-react';
import { loyaltyProgram } from '../data/mock';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const LoyaltyProgram = () => {
  const [cardRef, cardVisible] = useScrollAnimation(0.2);

  return (
    <section className="py-24 bg-black">
      <div className="max-w-5xl mx-auto px-6">
        <Card 
          ref={cardRef}
          className={`bg-gradient-to-br from-neutral-950 to-neutral-900 border-neutral-800 overflow-hidden relative scale-in ${cardVisible ? 'visible' : ''}`}
        >
          {/* Background Pattern */}
          <div className="absolute inset-0 opacity-5">
            <div className="absolute inset-0" style={{
              backgroundImage: 'repeating-linear-gradient(45deg, #fff 0, #fff 1px, transparent 0, transparent 50%)',
              backgroundSize: '10px 10px'
            }}></div>
          </div>

          <CardContent className="relative z-10 py-12 px-8">
            <div className="flex flex-col md:flex-row items-center gap-8 mb-12">
              {/* Icon */}
              <div className="flex-shrink-0">
                <div className="p-6 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 glow-on-scroll">
                  <Award className="w-16 h-16 text-white" />
                </div>
              </div>

              {/* Content */}
              <div className="flex-1 text-center md:text-left">
                <h3 className="text-3xl md:text-4xl font-bold text-white mb-3">
                  Digitális Hűségprogram
                </h3>
                <p className="text-gray-300 text-lg mb-6">
                  {loyaltyProgram.description}
                </p>
                
                {/* Two tier rewards */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-lg p-4">
                    <div className="flex items-center gap-2 mb-2">
                      <TrendingUp className="w-5 h-5 text-white" />
                      <span className="text-white font-semibold">{loyaltyProgram.visitsRequired}. látogatás után</span>
                    </div>
                    <div className="text-3xl font-bold text-white">
                      {loyaltyProgram.discountPercentage}% KEDVEZMÉNY
                    </div>
                  </div>
                  
                  <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-lg p-4">
                    <div className="flex items-center gap-2 mb-2">
                      <Percent className="w-5 h-5 text-white" />
                      <span className="text-white font-semibold">{loyaltyProgram.permanentDiscountThreshold.toLocaleString('hu-HU')} Ft után</span>
                    </div>
                    <div className="text-3xl font-bold text-white">
                      {loyaltyProgram.permanentDiscountPercentage}% ÁLLANDÓ
                    </div>
                  </div>
                </div>
              </div>

              {/* CTA */}
              <div className="flex-shrink-0">
                <button
                  onClick={() => document.getElementById('booking')?.scrollIntoView({ behavior: 'smooth' })}
                  className="bg-white text-black hover:bg-gray-200 font-semibold px-8 py-3 rounded-lg transition-all hover:scale-105"
                >
                  Gyűjtés kezdése
                </button>
              </div>
            </div>

            {/* Features */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 pt-8 border-t border-neutral-800">
              <div className="text-center">
                <p className="text-white font-semibold mb-1">Automatikus nyomon követés</p>
                <p className="text-gray-400 text-sm">
                  Altegio rendszer, minden digitális
                </p>
              </div>
              <div className="text-center">
                <p className="text-white font-semibold mb-1">Azonnali jutalom</p>
                <p className="text-gray-400 text-sm">
                  Kedvezmény a fizetéskor
                </p>
              </div>
              <div className="text-center">
                <p className="text-white font-semibold mb-1">Könnyű kezelés</p>
                <p className="text-gray-400 text-sm">
                  Haladás követése emailben
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default LoyaltyProgram;
